import React, { useMemo } from 'react';
import { Button, Badge } from 'react-bootstrap';
import RoleActionsCell from './RoleActionsCell';

const useRoleColumns = ({ handleToggleStatus, handleEdit, handleDelete }) => {
    return useMemo(() => [
        { accessorKey: 'id', header: 'ID' },
        { accessorKey: 'role_name', header: 'Role Name' },
        { id: 'project_name', accessorFn: (row) => row.project?.project_name || '', header: 'Project' },
        { accessorKey: 'required_gender', header: 'Gender' },
        { accessorKey: 'required_age', header: 'Age Range' },
        {
            accessorKey: 'status',
            header: 'Status',
            cell: info => (
                <Badge bg={info.getValue() === 'Open' ? 'success' : 'danger'}>{info.getValue()}</Badge>
            )
        },
        {
            id: 'toggle',
            header: 'Control',
            enableSorting: false,
            cell: (info) => {
                const status = info.row.original.status;
                return (
                    <Button
                        size="sm"
                        variant={status === 'active' ? 'success' : 'secondary'}
                        onClick={() => handleToggleStatus(info.row.original.id, info.row.original)}
                    >
                        {status === 'active' ? 'Deactivate' : 'Activate'}
                    </Button>
                );
            }
        },
        {
            id: 'actions',
            header: () => <div style={{ textAlign: 'center', width: '100%' }}>ACTIONS</div>,
            enableSorting: false,
            cell: (info) => {
                const role = info.row.original;
                return (
                    <RoleActionsCell
                        roleId={role.id}
                        roleName={role.role_name}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                    />
                );
            },
        }
    ], [handleToggleStatus, handleEdit, handleDelete]);
};

export default useRoleColumns;
